import { IAdminException, IAdminExceptionProps } from "../interfaces";
import { ExceptionTypes } from "./ExceptionTypes";

export default class AdminExceptionHelper {
  static getExceptionFields(exceptions: string, isCounter?:boolean): {
    isSerialNoException: boolean;
    isLotException: boolean;
    isCartonException: boolean;
    isPalletException: boolean;
    isMisMatchQty: boolean;
  } {
    const lstExceptionType = Array.from(
      new Set(
        exceptions
          .split(',')
          .map(e => parseInt(e.trim(), 10))
          .filter(n => !isNaN(n))
      )
    );
    return {
      isSerialNoException: ExceptionTypes.some(
        e => (!isCounter || e.isAdminOnlyView === false) && e.isSerialNoException && lstExceptionType.includes(e.id)
      ),
      isLotException: ExceptionTypes.some(
        e => (!isCounter || e.isAdminOnlyView === false) && e.isLotException && lstExceptionType.includes(e.id)
      ),
      isCartonException: ExceptionTypes.some(
        e => (!isCounter || e.isAdminOnlyView === false) && e.isCartonException && lstExceptionType.includes(e.id)
      ),
      isPalletException: ExceptionTypes.some(
        e => (!isCounter || e.isAdminOnlyView === false) && e.isPalletException && lstExceptionType.includes(e.id)
      ),
      isMisMatchQty:ExceptionTypes.some(
        e =>(!isCounter || e.isAdminOnlyView === false) && lstExceptionType.includes(e.id)
      ),
    };
  }

  static adminException(exceptions?: IAdminExceptionProps, isUnaccepted?:boolean | false): IAdminException {
      const rawExceptions = isUnaccepted
    ? exceptions?.unacceptedExceptions
    : exceptions?.exceptions;
    if (!exceptions || !rawExceptions) {
      return {
        isException: false,
        tooltipTitle: "",
        tooltipMessage: "",
        tooltipLockMessage: "",
        bannnerTitle: "",
        bannerMessage: "",
        isSerialNoException: false,
        isLotException: false,
        isCartonException: false,
        isPalletException: false
      };
    }

    const lstExceptionType = Array.from(
      new Set(
        rawExceptions
          .split(',')
          .map(e => parseInt(e.trim(), 10))
          .filter(n => !isNaN(n))
      )
    );

    let matchedExceptions = ExceptionTypes.filter(e => lstExceptionType.includes(e.id) && (!exceptions.isCounter || e.isAdminOnlyView === false));
    if(exceptions.isSpecific){
      if(exceptions.isSerial){
        matchedExceptions = matchedExceptions.filter(x=>x.isSerialNoException === true);
      }
      else if(exceptions.isLot){
        matchedExceptions = matchedExceptions.filter(x=>x.isLotException === true);
      }
      else if(exceptions.isCarton){
        matchedExceptions = matchedExceptions.filter(x=>x.isCartonException === true);
      }
      else if(exceptions.isPallet){
        matchedExceptions = matchedExceptions.filter(x=>x.isPalletException === true);
      }
    }
    const isException = matchedExceptions.length > 0;

    if (!isException) {
      return {
        isException: false,
        tooltipTitle: "",
        tooltipMessage: "",
        tooltipLockMessage: "",
        bannnerTitle: "",
        bannerMessage: "",
        isSerialNoException: false,
        isLotException: false,
        isCartonException: false,
        isPalletException: false
      };
    }

    let tooltipTitle = "";
    let tooltipMessage = "";
    let tooltipLockMessage = "";
    let bannnerTitle = "";
    let bannerMessage = "";

    if (matchedExceptions.length > 1) {
      tooltipTitle = "Exception";
      bannnerTitle = "Inventory Exception: ";
      tooltipMessage =
        matchedExceptions.map(e => e.tooltipMessages).join(", ") +
        "  Exception.";
      tooltipLockMessage =
        matchedExceptions.map(e => e.tooltipMessages).join(", ") +
        "  Exception. Update in Inventory or Lock the Inventory for review.";
      bannerMessage =
        matchedExceptions.map(e => e.bannerMessages).join(", ") +
        ". Please verify and update it before locking the Inventory.";
    } else {
      const single = matchedExceptions[0];
      tooltipTitle = single.fullTooltipTitle || "Exception";
      tooltipMessage = single.fullTooltipMessages || "";
      tooltipLockMessage = single.fullTooltipLockMessages || "";
      bannnerTitle = single.fullBannnerTitle || "Inventory Exception: ";
      bannerMessage = single.fullBannerMessages || "";
    }

    const flags = this.getExceptionFields(rawExceptions, exceptions.isCounter);
    return {
      isException,
      tooltipTitle,
      tooltipMessage,
      tooltipLockMessage,
      bannnerTitle,
      bannerMessage,
      ...flags
    };
  }
}
